var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9716",
    "data-name": "Group 9716",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.109,
    height: 17.076,
    viewBox: "0 0 17.109 17.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3024",
    "data-name": "Rectangle 3024",
    width: 17.109,
    height: 17.076,
    fill: "#77ffa5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9715",
    "data-name": "Group 9715",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26716",
    "data-name": "Path 26716",
    d: "M14.6,2.49A8.443,8.443,0,0,0,8.554,0,8.443,8.443,0,0,0,2.506,2.49a8.549,8.549,0,0,0,0,12.1,8.443,8.443,0,0,0,6.048,2.49,8.443,8.443,0,0,0,6.048-2.49,8.549,8.549,0,0,0,0-12.1m-1,11.1a7.042,7.042,0,0,1-5.051,2.064A7.042,7.042,0,0,1,3.5,13.589a7.168,7.168,0,0,1,0-10.1A7.042,7.042,0,0,1,8.554,1.423,6.832,6.832,0,0,1,13.6,3.558a7.083,7.083,0,0,1,0,10.031",
    transform: "translate(0)",
    fill: "#77ffa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26717",
    "data-name": "Path 26717",
    d: "M12.344,8.058H9.5V5.212a.712.712,0,1,0-1.423,0V8.058H5.229a.712.712,0,1,0,0,1.423H8.075v2.846a.712.712,0,0,0,1.423,0V9.481h2.846a.712.712,0,1,0,0-1.423",
    transform: "translate(-0.232 -0.231)",
    fill: "#77ffa5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.a4321e59f54033ed522acf028c20cfce.svg";
export { ForwardRef as ReactComponent };